module.exports = __webpack_public_path__ + "static/img/bg-ar.4665dce8.webp";